import { useState, useEffect, useRef } from 'react';
import api from '../services/api';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Polls /api/version every 5 minutes. Returns `updateAvailable = true`
 * once the server version changes (i.e., a new deployment has occurred).
 */
const useAppVersion = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialVersion = useRef(null);

  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get('/version');
        if (initialVersion.current === null) {
          initialVersion.current = data.version;
        } else if (data.version !== initialVersion.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // Silently ignore network errors — don't annoy user if offline
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') check();
    };

    check();
    const timer = setInterval(check, POLL_INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return { updateAvailable };
};

export default useAppVersion;
